import InventoryRoutes from "./inventory";
import StockTakeRoutes from "./stock-take";
import GridReportRoutes from "./grid-reports";

export default [
    ...InventoryRoutes,
    ...StockTakeRoutes,
    ...GridReportRoutes
];
